<template>
    <v-app id="onHpbz">

        <navbar :actions="hpbz.action_items" @actionClick="actionClick"/>

        <v-main> 
            <v-container fluid>
<!-- header -->            
                <v-row>  
                    <v-col cols="12" class="px-4">                         
                        <v-card>                                  
                            <v-card-title>
                                <v-row class="mt-0 mb-1 ml-0 flex">      
                                    {{ hpbz.hust_oms }} 
                                    {{ hpbz.hpbz_code }}
                                    <v-chip :color=hpbz.hust_kleur class="mx-4"> {{hpbz.hust_code}} </v-chip>
                                    {{hpbz.hpbz_type}}                                    
                                    <send_mail_info :hpbz_encrid="hpbz.hpbz_encrid" class="mb-1 ml-4"/>           
                                    <div style="font-size: small;" v-if="hpbz.hpbz_plan_operto_id!==''">
                                        <div class="flex">
                                            <div class="mr-2" style="width: 140px">Operto ID planning: </div><div class="mr-2">{{ hpbz.hpbz_plan_operto_id }}</div> 
                                        </div>
                                        <div class="flex">
                                            <div class="mr-2" style="width: 140px">Operto ID booking: </div><div class="mr-2">{{ hpbz.hpbz_operto_id }}</div>                                                                         
                                        </div>                                    
                                    </div>
                                    <v-spacer></v-spacer>
                                    <div class="mx-4"><btn_audit table="hpbz" :encrid="hpbz_encrid" :size=30 tooltip="audit of hpbz"/></div>
                                    <mail_button v-if="hpbz.hpbz_type!=='ImportedBooking'" :mails="hpbz.mails" :encrid="hpbz.hpbz_encrid" @showDialog="showMailDialog" />   
                                </v-row>  
                            </v-card-title>                              
                            <v-row class="ma-2 mb-3"><v-divider></v-divider></v-row>
                            <v-card-text>
                                <v-row no-gutters>
                                    <v-col cols="2" class="pr-4">
                                        <v-text-field v-model="hpbz.hpbz_dt" readonly label="Booking date"></v-text-field>
                                    </v-col>
                                    <v-col cols="3" class="pr-4">
                                        <v-text-field v-model="hpbz.hpbz_booked_by" readonly label="Booked by"></v-text-field>
                                    </v-col>
                                    <v-col cols="3" class="pr-4">
                                        <v-text-field v-model="hpbz.hpbz_van_samengesteld" readonly label="Arrival"></v-text-field>
                                    </v-col>
                                    <v-col cols="3" class="pr-4">
                                        <v-text-field v-model="hpbz.hpbz_tm_samengesteld" readonly label="Departure"></v-text-field>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-text-field v-model="hpbz.hpbz_aant_nacht" readonly label="Nights"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        
                        </v-card>
                    </v-col>
                </v-row>

<!-- body = updateble values -->

                <v-card class="pl-0 mt-5 ml-1 mr-1">
                    <v-row no-gutters>
                        <v-col cols="6">
                            <v-card flat>
                                <v-card-title>Guest</v-card-title>
                                <v-card-text>
                                    <guest :isReadOnly="isDisabled(hpbz)" :guest="guest" @updateData="updateData"/>      
                                </v-card-text>             
                            </v-card>                  
                        </v-col> 
                        <v-col cols="6" class="pl-4">
                            <v-card flat>
                                <v-card-title>Travelparty</v-card-title>
                                <v-card-text>
                                    <travelparty :isReadOnly="isDisabled(hpbz)" :numRowsRemark="7" :travelparty="travelparty" @updateData="updateData"/>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row> 
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-card flat>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" :disabled="mailSend===true||isDisabled(hpbz)" small v-on:click="updateHpbz(hpbz.hpbz_type)"><v-icon medium class="mr-2" v-if="buttonIcon!==''">{{ this.buttonIcon }}</v-icon>{{ this.buttonCaption }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>                    
                    </v-row>
                </v-card>

            </v-container>
        </v-main>
        <mails_dialog ref="mailDialog"/>
        <warning ref="warning" @processWarning="processWarning"/>
        <question ref="question" :hpbz_encrid="hpbz.hpbz_encrid" @processQuestion="processQuestion"/>
        <cancelHpbz ref="cancelHpbz"></cancelHpbz>
    </v-app>
</template>

<script>
import btn_audit from "@/components/ui/buttons/btn_audit.vue";
import cancelHpbz from "@/views/hpbz/cancelHpbz.vue";
import travelparty from '@/components/plan/hpbz/travelparty.vue'
import guest from '@/components/plan/hpbz/guest.vue'
import mail_button from '@/components/ui/buttons/btn_mails.vue'
import mails_dialog from '@/components/plan/hpbz/showMails.vue'
import send_mail_info from '@/components/plan/hpbz/send_mail_info.vue'
import warning from '@/components/plan/hpbz/warning.vue'
import question from '@/components/plan/hpbz/question.vue'
import navbar from '@/components/plan/hpbz/navbar.vue'

export default {
    components: {
        btn_audit,
        cancelHpbz,
        travelparty,
        guest,
        mail_button,
        mails_dialog,          
        send_mail_info,
        warning,
        question,
        navbar
    },
    props: ['hpbz_encrid', 'huis_encrid'],
    data() {
        return {
            hpbz: {
                action_items: []  /* moet pre defined ivm length check */
            },
            snackbar: false,
            snackbarMessage: '',
            travelparty: { adults: '0', children: '0', babys: '0', pets: '0', remark: '' },
            guest: { name: '', email: '', telephone: '', address: '', city: '' },
            mailSend: false,
            buttonCaption: 'Update',
            buttonIcon: '',
        }

    },
    mounted() {
        this.getHpbz();
    },
    methods: {
        actionClick(action) {
            if (action == "Cancel") {
                this.$refs.cancelHpbz.open(this.hpbz_encrid, this.huis_encrid);
            }
            if (action == "Confirmation") {
                this.$refs.question.open(this.hpbz_encrid, this.huis_encrid);
            }            
        },
        showMailDialog(encrid){
            this.$refs.mailDialog.open(encrid);
        },  
        updateData(data){
            this[data.field] = data.value;
        },        
        isDisabled(hpbz) {
            return !(hpbz.hpbz_type!=='HostBooking'&&hpbz.hpbz_type!=='importedBooking')
        },
        getHpbz(){
            this.$axios
                .post("ares/json/ares/hpbz/getHpbz.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHpbz"
                    },
                    getHpbz: {
                        hpbz_encrid: this.hpbz_encrid,
                        huis_encrid: this.huis_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hpbz = res.data.getHpbz;
                        document.title = 'Host booking ' + res.data.getHpbz.hpbz_code;
                        // create travelparty and guest object
                        this.travelparty = {
                            adults: this.hpbz.hpbz_aant_volw,
                            children: this.hpbz.hpbz_aant_kind,
                            babys: this.hpbz.hpbz_aant_baby,
                            pets: this.hpbz.hpbz_aant_hd,
                            remark: this.hpbz.hpbz_opm
                        };
                        this.guest = {
                            name: this.hpbz.hpbz_klnt_naam,
                            email: this.hpbz.hpbz_klnt_email,
                            telephone: this.hpbz.hpbz_klnt_telefoon,
                            address: this.hpbz.hpbz_klnt_adres,
                            city: this.hpbz.hpbz_klnt_plaats
                        };
                    }
                });            
        },  
        resendConfirmation(){
            console.log('resend');
            this.$axios
                .post("ares/json/ares/hpbz/sendConfirmation.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "resendMail"
                    },
                    resendMail: {            
                        hpbz_encrid: this.hpbz.hpbz_encrid,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log('error', res.data.error);
                        // laten we hopen dat dit nooit gebeurt, anders zetten we de gebruiker vast in dit dialog met een melding of iets (komt later)
                    } else { 
                        this.hpbz.mails += res.data.resendMail.mail_sent;
                    }
                });
        },
        processUpdate(){
            console.log('do it');
            this.$axios
                .post("ares/json/ares/hpbz/updHpbz.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHpbz"
                    },
                    updHpbz: {            
                        hpbz_encrid: this.hpbz.hpbz_encrid,
                        guest: this.guest,
                        travelparty: this.travelparty,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log('error', res.data.error);
                        // laten we hopen dat dit nooit gebeurt, anders zetten we de gebruiker vast in dit dialog met een melding of iets (komt later)
                    } else { 
                        this.mailSend = true;
                        this.buttonCaption = 'Done';
                        this.buttonIcon = 'mdi-check-circle-outline';
                        this.hpbz.mails += res.data.updHpbz.mail_sent;
                    }
                });
        },
        processWarning(answer){
            answer==='yes' ? this.processUpdate() : false;
        },    
        processQuestion(answer){
            answer==='yes' ? this.resendConfirmation() : false;
        },            
        updateHpbz(type) {
            this.$refs.warning.open(type);
        }
    }
};

</script> 

<style scoped>
.flex{
    display: flex;
    flex-direction: row;
}
</style>